/** Lokāles-apzinīgi formatēšanas palīgi — lieto VISUR jēlu ISO virkņu vietā. */

export function formatDate(value: string | number | Date | null | undefined, locale: string) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium' }).format(d);
}

export function formatDateTime(value: string | number | Date | null | undefined, locale: string) {
  if (!value) return '—';
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return String(value);
  return new Intl.DateTimeFormat(locale, { dateStyle: 'medium', timeStyle: 'short' }).format(d);
}

/** Produkta nosaukums aktīvajā valodā ar EN → pirmā pieejamā atkāpšanos. */
export function productName(
  namesI18n: Record<string, string> | null | undefined,
  locale: string,
  fallback = '—',
): string {
  if (!namesI18n) return fallback;
  return (
    namesI18n[locale] ??
    namesI18n[locale.slice(0, 2)] ??
    namesI18n.en ??
    Object.values(namesI18n)[0] ??
    fallback
  );
}

/** Naudas/daudzuma formatēšana ar lokāli. */
export function formatNumber(value: number | string | null | undefined, locale: string) {
  if (value === null || value === undefined || value === '') return '—';
  const n = Number(value);
  if (Number.isNaN(n)) return String(value);
  return new Intl.NumberFormat(locale, { maximumFractionDigits: 2 }).format(n);
}
